import { createContext, useContext } from 'react';
import { User } from 'firebase/auth';

export enum AuthProvider {
    google = 'google.com',
    emailAndPassword = 'password',
}

export interface AuthUser extends User {
    provider: AuthProvider;
    given_name: string;
    picture: string;
    family_name: string;
}

export interface AuthLoginPrams {
    authorizationParams?: {
        /**Organization ID */
        organization?: string;
        /**Invitation ID */
        invitation?: string;
        /**Invitation Email */
        email?: string;
    };
    appState?: {
        targetUrl?: string;
    };
}

export interface AuthLogoutPrams {
    logoutParams?: {
        returnTo?: string;
        navigateTo?: string;
    };
}

export interface AuthContextType {
    user: AuthUser | null;
    loading: boolean;
    isAuthenticated: boolean;
    loginWithRedirect: (params?: AuthLoginPrams) => Promise<void>;
    logout: (params?: AuthLogoutPrams) => Promise<void>;
    getAccessTokenSilently: () => Promise<string>;
    error: any;
    setError: React.Dispatch<any>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
    undefined,
);

const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error(
            'useFirebaseAuth must be used within a FirebaseProvider',
        );
    }
    return context;
};

export default useAuth;
